// Import the CSS for all examples
import '../assets/css/main.css'

// Load the example of your choice
//import { init } from './examples/model-playground';
import { init } from './scrolling-uvs';

// Start demo
init()